import baseAPI from "@/http";

const router = "api/TerritorioFase";

export const territorioFaseAPI = {
  list: () => baseAPI.get(router),
};
